/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\aiAgentsDynamicContextService.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the AI Integration module.
────────────────────────────────────────────────────────────────*/


import { buildApiUrl, getApiHeaders } from '../../../config/api';
import { DynamicContext, DynamicContextInput } from './aiAgentsTypes';

const BASE_PATH = '/api/telephony/ai-agents';

export async function getDynamicContexts(agentId: number | string): Promise<DynamicContext[]> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/${agentId}/dynamic-contexts`), { method: 'GET', headers: getApiHeaders() });
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
    const result = await res.json();
    return result.data || [];
}

export async function createDynamicContext(agentId: number | string, data: DynamicContextInput): Promise<DynamicContext> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/${agentId}/dynamic-contexts`), { method: 'POST', headers: getApiHeaders(), body: JSON.stringify(data) });
    if (!res.ok) { const e = await res.json().catch(() => ({ error: res.statusText })); throw new Error(e.error || `HTTP ${res.status}`); }
    return (await res.json()).data;
}

export async function updateDynamicContext(agentId: number | string, contextId: number | string, data: Partial<DynamicContextInput>): Promise<DynamicContext> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/${agentId}/dynamic-contexts/${contextId}`), { method: 'PUT', headers: getApiHeaders(), body: JSON.stringify(data) });
    if (!res.ok) { const e = await res.json().catch(() => ({ error: res.statusText })); throw new Error(e.error || `HTTP ${res.status}`); }
    return (await res.json()).data;
}

export async function deleteDynamicContext(agentId: number | string, contextId: number | string): Promise<void> {
    const res = await fetch(buildApiUrl(`${BASE_PATH}/${agentId}/dynamic-contexts/${contextId}`), { method: 'DELETE', headers: getApiHeaders() });
    if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
}
